import { WindowTitle } from "@saleor/components/WindowTitle";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import { sectionNames } from "@saleor/intl";
import React from "react";
import { useIntl } from "react-intl";

import ClusterCreatePage from "../components/ClusterCreatePage";
import { TypedClusterCreate } from "../mutations";
import { ClusterCreate } from "../types/ClusterCreate";
import { clusterListUrl, clusterUrl } from "../urls";

export const ClusterCreateView: React.FC = () => {
  const intl = useIntl();
  const navigate = useNavigator();
  const notify = useNotifier();

  const handleClusterCreate = (data: ClusterCreate) => {
    if (data.clusterCreate.errors.length === 0) {
      notify({
        status: "success",
        text: intl.formatMessage({
          defaultMessage: "Successfully created cluster"
        })
      });
      navigate(clusterUrl(data.clusterCreate.cluster.id), true);
    }
  };

  return (
    <TypedClusterCreate onCompleted={handleClusterCreate}>
      {(clusterCreate, clusterOpts) => (
        <>
          <WindowTitle title={intl.formatMessage(sectionNames.cluster)} />
          <ClusterCreatePage
            errors={clusterOpts.data?.clusterCreate.errors || []}
            onBack={() => navigate(clusterListUrl())}
            disabled={clusterOpts.loading}
            saveButtonBarState={clusterOpts.status}
            onSubmit={formData => {
              clusterCreate({
                variables: {
                  input: {
                    lowerPrepTimeDays: parseInt(formData.lowerPrepTimeDays, 0),
                    lowerPrepTimeHours: parseInt(
                      formData.lowerPrepTimeHours,
                      0
                    ),
                    lowerPrepTimeMins: parseInt(formData.lowerPrepTimeMins, 0),
                    name: formData.name,
                    productType: "UHJvZHVjdFR5cGU6Mw==",
                    upperPrepTimeDays: parseInt(formData.upperPrepTimeDays, 0),
                    upperPrepTimeHours: parseInt(
                      formData.upperPrepTimeHours,
                      0
                    ),
                    upperPrepTimeMins: parseInt(formData.upperPrepTimeMins, 0)
                  }
                }
              });
            }}
          />
        </>
      )}
    </TypedClusterCreate>
  );
};

export default ClusterCreateView;
